module.exports = __webpack_public_path__ + "media/wyposazenie/kolor@2x-1d079caa.png";